import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

//retirar para visualizar los logs
//if (true) {
//console.log = () => {};
//console.error = () => {};
//console.debug = () => {};
//console.info = () => {};
//console.warn = () => {};
//}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
